const countries = (state) => {
  let result = state.countries && Object.keys(state.countries).length > 0 ? Object.values(state.countries) : []
  return result.sort(function (a, b) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1
    }
    return 0
  })
}

const getCountryById = (state, getters) => (id) => {
  let result = state.countries && Object.keys(state.countries).length > 0 ? state.countries : []
  var data = result && id in result ? result[id] : false
  return data
}

export default {
  countries,
  getCountryById
}



// WEBPACK FOOTER //
// ./src/store/modules/countries/getters.js